__turbopack_context__.v({
  "accordionButton": "tPiphW_accordionButton",
  "accordionClose": "tPiphW_accordionClose",
  "accordionOpen": "tPiphW_accordionOpen",
  "accordionPanel": "tPiphW_accordionPanel",
  "accordionPanelContent": "tPiphW_accordionPanelContent",
  "arrowIcon": "tPiphW_arrowIcon",
  "contentItemWrapper": "tPiphW_contentItemWrapper",
  "contentItemWrapperActive": "tPiphW_contentItemWrapperActive",
  "contentItemWrapperWithIcon": "tPiphW_contentItemWrapperWithIcon",
  "labelWrapper": "tPiphW_labelWrapper",
  "subMenuContent": "tPiphW_subMenuContent",
  "subMenuTrigger": "tPiphW_subMenuTrigger",
  "wrapperCollapsed": "tPiphW_wrapperCollapsed",
});
